var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "1280px",
      "max-width": "85%"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "text": ""
          }
        }, 'v-btn', attrs, false), on), [_vm._v(" " + _vm._s(_vm._requestees.length) + " 명 ")])];
      }
    }]),
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "text-h5 grey lighten-2"
  }, [_vm._v(" 자문인력배정 "), _c('v-spacer'), _c('v-icon', {
    on: {
      "click": function click($event) {
        _vm.dialog = false;
      }
    }
  }, [_vm._v(" mdi-close")])], 1), _c('v-card-text', [_c('v-row', [_c('v-col', [_vm._v(" 배정된 자문인력 "), _c('v-data-table', _vm._b({
    attrs: {
      "items": _vm.requestees
    },
    scopedSlots: _vm._u([{
      key: "item.areas",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('counsels-requestees-areas', {
          attrs: {
            "areas": item.areas,
            "request": _vm.value
          }
        })];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('v-icon', {
          attrs: {
            "color": "secondary"
          },
          on: {
            "click": function click($event) {
              return _vm.removeRequestee(item);
            }
          }
        }, [_vm._v("mdi-minus-circle")])];
      }
    }], null, true)
  }, 'v-data-table', _vm.tableProps, false))], 1)], 1), _c('v-row', [_c('v-col', [_vm._v(" 미배정된 자문인력 "), _c('v-data-table', _vm._b({
    attrs: {
      "items": _vm.candidates
    },
    scopedSlots: _vm._u([{
      key: "item.areas",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('counsels-requestees-areas', {
          attrs: {
            "areas": item.areas,
            "request": _vm.value
          }
        })];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c('v-icon', {
          attrs: {
            "color": "primary"
          },
          on: {
            "click": function click($event) {
              return _vm.addRequestee(item);
            }
          }
        }, [_vm._v("mdi-plus-circle")])];
      }
    }], null, true)
  }, 'v-data-table', _vm.tableProps, false))], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }